// utils to delay promise
function wait(ms) {
  return x => {
    return new Promise(resolve => setTimeout(() => resolve(x), ms));
  };
}

function toggle() {
  console.log(document.getElementById("sidebar"));
}

function calendarYearList() {
  let data = [
     { value: 2026, name: "Current School Year - 2025/2026", short: "2025/26", current: true },
  { value: 2025, name: "2024/25", short: "2024/25", },
    { value: 2024, name: "2023/2024", short: "2023/24", },
    { value: 2023, name: "2022/2023", short: "2022/23", },
    { value: 2022, name: "2021/2022", short: "2021/22", },
    { value: 2021, name: "2020/2021", short: "2020/21", },
    { value: 2020, name: "2019/2020", short: "2019/20", },
    { value: 2019, name: "2018/19", short: "2018/19", },
    { value: 2018, name: "2017/18", short: "2017/18", }
  ];
  return data;
}

function termList() {
  return [
    { key: "autumn1", name: "Autumn 1" },
    { key: "autumn2", name: "Autumn 2" },
    { key: "spring1", name: "Spring 1" },
    { key: "spring2", name: "Spring 2" },
    { key: "summer1", name: "Summer 1" },
    { key: "summer2", name: "Summer 2" }
  ];
}

function filterTypeList() {
  return [
    { id: 1, value: "female", name: "Female" },
    { id: 2, value: "male", name: "Male" },
    { id: 3, value: "sen", name: "SEN" },
    { id: 4, value: "premium", name: "Pupil Premium" },
    { id: 5, value: "eal", name: "EAL" }
  ];
}

function courseTypeList(id) {
  let data = [
    { id: 1, value: "free" },
    { id: 2, value: "paid" },
    { id: 3, value: "school" },
    { id: 4, value: "organisation" },
    { id: 5, value: "community" },
    { id: 6, value: "pippaeddie" }
    
  ];

  return data.find(function (object) {
    return object.id === id;
  });
}

function layoutTypeList() {
  return [
    { key: "file", name: "Document" },
    { key: "textonly", name: "Text Only" },
    { key: "fields", name: "Form Fields with Main Document" },
    { key: "fieldscon", name: "Form Fields with Main Textbox" },
    { key: "empty", name: "Empty" }
  ];
}

function reportGridCalculation(type, list) {

  let registerLength = list.reduce(function (previous, current) {
    if (type == "male" || type == "female") {
      let pupils = current.pupils != undefined ? current.pupils : [];
      let registersByType = pupils.filter(function (reg) {
        return reg.gender.toLowerCase() == type;
      });
      return previous + registersByType.length;
    } else if (type == "premium") {
      let pupils = current.pupils != undefined ? current.pupils : [];
      let registersByPP = pupils.filter(function (reg) {
        return reg.premium_pupil > 0;
      });
      return previous + registersByPP.length;
    } else if (type == "sen") {
      let pupils = current.pupils != undefined ? current.pupils : [];
      let registersBySEN = pupils.filter(function (reg) {
        let sen = reg.sen_status == null ? "" : reg.sen_status
        return sen.toLowerCase().startsWith("sen");
      });
      return previous + registersBySEN.length;
    } else if (type == "eal") {
      let pupils = current.pupils != undefined ? current.pupils : [];
      let registersByPP = pupils.filter(function (reg) {
        return reg.english_second > 0;
      });
      return previous + registersByPP.length;
    } else {
      let pupils = current.pupils != undefined ? current.pupils : [];
      return previous + pupils.length;
    }
  }, 0);

  return registerLength;
}

function uniqueOnlyRegisters(list) {
  return list.reduce((unique, o) => {
    if (!unique.some(obj => obj.pupil_identifier === o.pupil_identifier)) {
      unique.push(o);
    }
    return unique;
  }, []);
}

function reportGridCountCalculation(type, list) {

  let registerFilter = list.flatMap(function (activity) {
    return activity.pupils != undefined ? activity.pupils : [];
  });

  let uniqueRegisters = uniqueOnlyRegisters(registerFilter)
  
  if (type == "male" || type == "female") {
    let registerByGender = uniqueRegisters.filter(reg => {
      return reg.gender.toLowerCase() == type;
    });
    return registerByGender.length;
  } else if (type == "premium") {
    let registersByPP = uniqueRegisters.filter(reg => {
      return reg.premium_pupil > 0;
    });
    return registersByPP.length;
  } else if (type == "sen") {
    let registersBySEN = uniqueRegisters.filter(reg => {
      let sen = reg.sen_status == null ? "" : reg.sen_status
      return sen.toLowerCase().startsWith("sen");
    });
    return registersBySEN.length;
  } else if (type == "eal") {
    let registersByEAL = uniqueRegisters.filter(function (reg) {
      return reg.english_second > 0;
    });
    return registersByEAL.length;
  } else {
    return uniqueRegisters.length;
  }
}

function colours() {
  return [
    { colour: "247,204,204" },
    { colour: "244,217,234" },
    { colour: "209,204,247" },
    { colour: "204,225,247" },
    { colour: "240,247,204" },
    { colour: "247,237,204" },
    { colour: "233,222,242" },
    { colour: "204,225,247" },
    { colour: "247,204,204" },
    { colour: "244,217,234" },
    { colour: "209,204,247" },
    { colour: "204,225,247" },
    { colour: "240,247,204" },
    { colour: "247,237,204" },
    { colour: "233,222,242" },
    { colour: "204,225,247" }
  ];
}

function timesframes() {
  return [
    { "title": "Breakfast", "time_value": "breakfast" },
    { "title": "Lunch", "time_value": "lunch" },
    { "title": "After School", "time_value": "after-school" }
  ]
}

function eventTypes() {
  return [
    { id: 1, "name": "PE Based", "value": "education", class: "bg-red-200" },
    { id: 2, "name": "Health based", "value": "health", class: "bg-green-200" },
    { id: 3, "name": "CPD", "value": "cpd", class: "bg-yellow-200" },
    { id: 4, "name": "Swimming", "value": "swimming", class: "bg-blue-200" },
    { id: 5, "name": "Other", "value": "other", class: "bg-gray-200" },
  ]
}

function ecTypes() {
  return [
    { id: 1, "name": "PE Based", "value": "physical", class: "bg-red-200" },
    { id: 2, "name": "Educational", "value": "education", class: "bg-orange-200" },
    { id: 3, "name": "Health based", "value": "health", class: "bg-green-200" },
    { id: 4, "name": "CPD", "value": "cpd", class: "bg-yellow-200" },
    { id: 5, "name": "Swimming", "value": "swimming", class: "bg-blue-200" },
    { id: 6, "name": "Other", "value": "other", class: "bg-gray-200" },
  ]
}

function eventLevels() {
  return [
    { id: 1, "name": "No Level", "value": 0 },
    { id: 2,"name": "Level One", "value": 1 },
    { id: 3,"name": "Level Two", "value": 2 },
    { id: 4, "name": "Level Three", "value": 3 },
    ]
}


function eventStandards() {
  return [
    { id: 1, "name": "No standard set", "value": "none" },
    { id: 2, "name": "First Team", "value": "firstTeam" },
    { id: 3, "name": "Second Team", "value": "secondTeam" },
    { id: 4, "name": "Third Team", "value": "thirdTeam" },
    { id: 5, "name": "Fourth Team", "value": "fourthTeam" },
    { id: 6, "name": "Other", "value": "other" },
  ]
}

const expectancies = [
  {
    low: 1.68,
    high: 4.1,
    title: "Expected or Exceeding",
    color: "#FFEAAA",
    key: "expect_exceed"
  },
  {
    low: 2.34,
    high: 4.1,
    title: "Exceeding",
    color: "#A3E9D2",
    key: "exceeding"
  },
  {
    low: 1.68,
    high: 2.34,
    title: "Expected",
    color: "#A7C2FF",
    key: "expected"
  },
  {
    low: 0.0,
    high: 1.68,
    title: "Working Towards",
    color: "#FBB3B3",
    key: "working"
  }
]

function libraryFolders(schoolType) {
  if (["secondary", "international"].includes(schoolType)) {
    return [
      { id: 3, value: "nfl", name: "American Football" },
      { id: 4, value: "athletics", name: "Athletics"  },
      { id: 5, value: "badminton", name: "Badminton" },
      { id: 6, value: "basketball", name: "Basketball" },
      { id: 7, value: "cricket", name: "Cricket" },
      { id: 8, value: "dance", name: "Dance" },
      { id: 9, value: "fitness", name: "Fitness" },
      { id: 10,  value: "football", name: "Football" },
      { id: 11, value: "futsal", name: "Futsal" },
      { id: 12, value: "gcse", name: "GCSE" },
      { id: 13, value: "gymnastics", name: "Gymnastics" },
      { id: 14, value: "handball", name: "Handball" },
      { id: 15, value: "home_learning", name: "Home Learning" },
      { id: 16, value: "hockey", name: "Hockey" },
      { id: 17, value: "netball", name: "Netball" },
      { id: 18, value: "non_performer", name: "Non-Performer Worksheets" },
      { id: 19, value: "oaa", name: "OAA" },
      { id: 20, value: "plenaries", name: "Plenaries" },
      { id: 21, value: "rounders", name: "Rounders" },
      { id: 22, value: "rugby", name: "Rugby" },
      { id: 23, value: "softball", name: "Softball" },
      { id: 24, value: "squase", name: "Squash" },
      { id: 25, value: "swimming", name: "Swimming" },
      { id: 26, value: "table_tennis", name: "Table Tennis" },
      { id: 27, value: "tennis", name: "Tennis" },
      { id: 28, value: "trampolining", name: "Trampolining" },
      { id: 29, value: "volleyball", name: "Volleyball" },
      { id: 30, value: "warm_down", name: "Warm Ups / Cool Downs" },
    ]
  } else {
    return [
      { id: 2, value: "school", name: "My Documents", icon: "fa-house-user"  },
      { id: 3, value: "endpoint", name: "PE End Points"  },
      { id: 4, value: "knowledge", name: "Knowledge Organisers" },
      { id: 5, value: "roadmap", name: "Road Maps" },
      { id: 6, value: "ska", name: "Know, Show and Grow Progressions" },
      { id: 7, value: "vocab", name: "Vocabulary Lists" },
      { id: 8, value: "afpe", name: "AFPE Provided" },
      { id: 9,  value: "healthsafety", name: "Healthy and Safety" },
      { id: 10, value: "teacherguide", name: "Teacher Guidance" },
      { id: 11, value: "subjectleader", name: "Subject Leader" },
      { id: 12, value: "support", name: "PE Passport Support" },
      { id: 13, value: "swim", name: "Swimming" },
    ]
  }
 
}

export {
  wait,
  termList,
  filterTypeList,
  layoutTypeList,
  calendarYearList,
  uniqueOnlyRegisters,
  reportGridCalculation,
  reportGridCountCalculation,
  toggle,
  courseTypeList,
  colours,
  timesframes,
  eventTypes,
  eventLevels,
  eventStandards,
  ecTypes,
  expectancies,
  libraryFolders
};
